export default __webpack_public_path__ + "static/media/Monger-HUD-3D (Environmental Scan).7e379796.jpg";